import EfSpec from 'elem/ui/ef-spec';
import { useMemo } from 'react';
// import { getIsMobileWidth } from '@elem/utils/devices';
import EcoLink from 'eco-design/base/eco-link';
import { RuleTabModuleIdEnum } from '../Tab';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const ArrowIcon = () => (
    <svg className="C-list-item-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
);

export default function PageComp() {
    const { t } = useLang('rule');

    const authList = useMemo(
        () => [
            // {
            //     title: t('C_list_title1'),
            //     desc: t('C_list_desc1'),
            //     url: 'https://websiteoss.ecoflow.com/upload/image/1727232207572/auth-logo1.jpg',
            // },
            {
                title: t('C_list_title2'),
                desc: t('C_list_desc2'),
                url: 'https://websiteoss.ecoflow.com/upload/image/1727232208173/auth-logo3.jpg',
            },
            {
                title: t('C_list_title3'),
                desc: t('C_list_desc3'),
                url: 'https://websiteoss.ecoflow.com/upload/image/1727232208173/auth-logo3.jpg',
            },
            {
                title: t('C_list_title4'),
                desc: t('C_list_desc4'),
                url: 'https://websiteoss.ecoflow.com/upload/image/1727232207963/auth-logo2.jpg',
                link: {
                    text: 'PSTI Statement',
                    herf: 'https://www.ecoflow.com/uk/psti-related',
                },
            },
            {
                title: t('C_list_title5'),
                desc: t('C_list_desc5'),
                url: 'https://websiteoss.ecoflow.com/upload/image/1727232207751/auth-logo4.jpg',
            },
            {
                title: t('C_list_title6'),
                desc: t('C_list_desc6'),
                url: 'https://websiteoss.ecoflow.com/upload/image/1727232208607/auth-logo6.jpg',
            },
            // {
            //     title: t('C_list_title7'),
            //     desc: t('C_list_desc7'),
            //     url: 'https://websiteoss.ecoflow.com/upload/image/1727232208430/auth-logo5.jpg',
            // },
            {
                title: t('C_list_title8'),
                desc: t('C_list_desc8'),
                url: 'https://websiteoss.ecoflow.com/upload/image/1727232208430/auth-logo5.jpg',
            },
            {
                title: t('C_list_title9'),
                desc: t('C_list_desc9'),
                url: 'https://websiteoss.ecoflow.com/upload/image/1727232207751/auth-logo4.jpg',
            },
            // {
            //     title: t('C_list_title10'),
            //     desc: t('C_list_desc10'),
            //     url: 'https://websiteoss.ecoflow.com/upload/image/1746238143963/img_v3_02lj.jpg',
            // },
            // {
            //     title: t('C_list_title11'),
            //     desc: t('C_list_desc11'),
            //     url: 'https://websiteoss.ecoflow.com/upload/image/1746238150603/image.png',
            // },
        ],
        [t],
    );

    // const [open, setOpen] = useState(!getIsMobileWidth());
    // const list = useMemo(() => {
    //     if (open) return authList;
    //     return authList.filter((_i, idx) => idx < 6);
    // }, [authList, open]);

    return (
        <div className={`${css['page-comp']}`} id={RuleTabModuleIdEnum.ComplianceQualifications}>
            <EfSpec />
            <p className="C-title">{t('C_title')}</p>
            <p className="C-desc">{t('C_desc')}</p>
            <ul className="C-list">
                {authList.map((item) => (
                    <li className="C-list-item" key={item.title}>
                        <img className="C-list-item-img" src={item.url} draggable={false} />
                        <p className="C-list-item-title">{item.title}</p>
                        <p className="C-list-item-desc">{item.desc}</p>
                        {item.link && (
                            <EcoLink
                                className="C-list-item-link"
                                children={
                                    <>
                                        {item.link.text}
                                        <ArrowIcon />
                                    </>
                                }
                                href={item.link.herf}
                                target="_blank"
                            />
                        )}
                    </li>
                ))}
            </ul>
            {/* {!open && (
                <div className="C-list-item-more" onClick={() => setOpen(true)}>
                    <span>{t('C_view_all')}</span>
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 6.01698L8 11.017L3 6.01698" stroke="#3F68E0" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
            )} */}
            <EfSpec />
        </div>
    );
}
